import VisualizarProdutos from './VisualizarProdutos';

export default VisualizarProdutos;
